import angular from 'angular';
import f from 'odata-filter-builder';
import { SYSTEM_INGREDIENT_ADDED, SYSTEM_INGREDIENT_EDITED, SYSTEM_INGREDIENT_DELETED } from 'common/messages';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './system-ingredients.html';

export default {
  templateUrl,
  bindings: {
    flex: '@',
    layout: '@',
    ingredients: '<',
    query: '<'
  },
  controller: class SystemIngredientsComponent {
    constructor($mdDialog, $scope, ToastService, SystemIngredientsService) {
      'ngInject';

      Object.assign(this, {
        $mdDialog,
        $scope,
        ToastService,
        SystemIngredientsService
      });
    }

    $onInit() {
      this.columns = [{
        FieldName: 'SystemIngredientName',
        DisplayName: 'Ingredient Name'
      }, {
        FieldName: 'IUtoMgConversiontRate',
        DisplayName: '1 IU to MG Conversion Rate'
      }];

      this.selectedIngredients = [];
    }

    onQueryChanged({ query }) {
      this.selectedIngredients = [];
      this.query = query;
      this.refreshResults();
    }

    onSearchTextChanged({ searchText }) {
      this.selectedIngredients = [];
      this.query = {
        ...this.query,
        filter: f().contains('SystemIngredientName', searchText)
      };

      this.refreshResults();
    }

    refreshResults() {
      this.promise = this.SystemIngredientsService.search(this.query);
      this.promise.then((r) => {
        this.ingredients = transformODataResponse(r);
      }).catch(error => this.ToastService.showError(error));
    }

    ingredientAdd() {
      const scope = angular.extend(this.$scope.$new(true), {
        ingredientChanged: $event => this.onIngredientAdded($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <system-ingredient-form
                dialog-title="Add New System Ingredient"
                submit-title="Add System Ingredient"
                ingredient-changed="ingredientChanged($event)">
              </system-ingredient-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    onIngredientAdded({ ingredient }) {
      this.SystemIngredientsService.add(ingredient)
        .then(() => {
          this.$mdDialog.hide();
          this.refreshResults();
          this.ToastService.showSuccess(SYSTEM_INGREDIENT_ADDED);
        }).catch(error => this.ToastService.showError(error));
    }

    ingredientEdit(ingredient) {
      const scope = angular.extend(this.$scope.$new(true), {
        ingredient: angular.copy(ingredient),
        ingredientChanged: $event => this.onIngredientEdited($event)
      });

      this.$mdDialog.show({
        clickOutsideToClose: true,
        fullscreen: true,
        scope,
        template: `
          <md-dialog class="flex-50">
            <md-dialog-content>
              <dialog-close/>
              <system-ingredient-form
                ingredient="ingredient"
                dialog-title="Edit System Ingredient"
                submit-title="Save Changes"
                ingredient-changed="ingredientChanged($event)">
              </system-ingredient-form>
            </md-dialog-content>
          </md-dialog>
          `
      });
    }

    ingredientDelete(ingredients) {
      const confirm = this.$mdDialog.confirm()
        .title('Are you sure?')
        .textContent('Once deleted, the selected ingredient(s) cannot be recovered!')
        .ok('Delete')
        .cancel('Cancel');

      this.$mdDialog.show(confirm).then(() => {
        const promises = [];
        for (let i = ingredients.length - 1; i >= 0; i -= 1) {
          promises.push(this.SystemIngredientsService.delete(ingredients[i].SystemIngredientId));
        }

        Promise.all(promises).then(() => {
          this.ToastService.showSuccess(SYSTEM_INGREDIENT_DELETED);
          this.refreshResults();
          this.selectedIngredients = [];
        }).catch(error => this.ToastService.showError(error));
      });
    }

    onIngredientEdited({ ingredient }) {
      this.SystemIngredientsService.update(ingredient)
        .then(() => {
          this.$mdDialog.hide();
          this.selectedIngredients = [];
          this.refreshResults();
          this.ToastService.showSuccess(SYSTEM_INGREDIENT_EDITED);
        }).catch(error => this.ToastService.showError(error));
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredients.component.js